import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ParagraphProgress } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { BookProgressActions } from '../book-progress/book-progress.actions';
import { mapParagraphProgress } from './paragraph-progress.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const PARAGRAPH_PROGRESS_FEATURE_KEY: string = 'paragraphProgress';

// eslint-disable-next-line
export interface ParagraphProgressState
  extends EntityState<ParagraphProgress> {}

export const paragraphProgressAdapter: EntityAdapter<ParagraphProgress> =
  createEntityAdapter<ParagraphProgress>();

export const initialParagraphProgressState: ParagraphProgressState =
  paragraphProgressAdapter.getInitialState({});

const reducer: ActionReducer<ParagraphProgressState, Action> = createReducer(
  initialParagraphProgressState,
  on(
    AuthActions.logoutSuccess,
    (): ParagraphProgressState => initialParagraphProgressState,
  ),
  on(
    BookProgressActions.getBookProgressSuccess,
    BookProgressActions.updateBookProgressSuccess,
    (state, action): ParagraphProgressState =>
      paragraphProgressAdapter.upsertMany(
        action.bookProgressResponse.paragraphProgresses.map(
          (paragraphProgress) => mapParagraphProgress(paragraphProgress),
        ),
        {
          ...state,
        },
      ),
  ),
);

export function paragraphProgressReducer(
  state: ParagraphProgressState | undefined,
  action: Action,
): ParagraphProgressState {
  return reducer(state, action);
}
